import type { ChapterTexts } from './types'

/**
 * Chapter 页面通用文案配置
 * 三个品牌共用的默认文案
 */
export const commonTexts: ChapterTexts = {
  loading: 'Loading...',
  unlockTitle: 'Unlock Now',
  unlockDesc: 'Show your support to inspire the writer to come\nupwith more fantastic stories',
  unlockChapterButton: '{coins} coins to read this episode',
  unlockBookButton: '{coins} coins to read the whole book',
  continueInApp: 'Continue to Read This book in APP',
  autoUnlock: 'Auto unlock',
  coinsBalance: 'Coins Balance: {coins} Coins',
  prevButton: 'Prev',
  nextButton: 'Next',
  unlockButton: 'Unlock',
  catalogueButton: 'Catalogue',
  themeSizeLabel: 'Size',
  fontSizeDecrease: 'A-',
  fontSizeIncrease: 'A+',
  coinsSuccessTitle: 'Congratulations!',
  coinsSuccessDesc1: 'Free to Read This Book During',
  coinsSuccessDesc2: 'Membership Validity-No Coins Needed',
  coinsSuccessButton: 'Ok',
  recommendTitle: 'You Might Also Like',
  recommendSeeAll: 'See All',
  payTemplateTitle: 'Chapter is locked',
  payTemplateDesc: 'Choose a recharge level and unlock chapters',
  payTemplateCoins: 'coins',
  payTemplateFree: 'Free',
  payTemplateGetCoins: 'Get {coins} Coins at once',
  payTemplateEarnCoins: 'Earn {coins} Coins ({daily}/day) from daily login',
}
